import React from "react";
import PropTypes from "prop-types";
import { Text } from 'grommet/components/Text';

export default class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.changePage = this.changePage.bind(this);
  }

  static propTypes = {
    pages: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    previousText: PropTypes.string,
    nextText: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object
  };

  static defaultProps = {
    previousText: 'Pagina precedente',
    nextText: 'Pagina successiva'
  };

  changePage(page) {
    const { page: currentPage, pages } = this.props;
    const activePage = currentPage + 1;

    if (page === activePage || page < 1 || page > pages) {
      return;
    }

    this.props.onPageChange(page - 1);
  }

  render() {
    const { page, pages, previousText, nextText, className = '', style = {} } = this.props;
    const activePage = page + 1;
    const isFirstPage = activePage === 1;
    const isLastPage = activePage === pages;

    const buttonStyle = {
      background: 'none',
      border: 'none',
      padding: '5px 10px',
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      fontSize: '12px',
      color: '#006fcf',
      margin: '0 5px',
      borderRadius: '4px',
      outline: 'none'
    };

    const disabledButtonStyle = {
      ...buttonStyle,
      color: '#999',
      cursor: 'not-allowed',
      opacity: 0.6
    };

    return (
      <nav aria-label="Navigazione pagine" className={className} style={style}>
        <div style={{
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '10px'
        }}>
          {/* PREVIOUS PAGE BUTTON */}
          <button
            onClick={() => this.changePage(activePage - 1)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.changePage(activePage - 1);
              }
            }}
            disabled={isFirstPage}
            style={isFirstPage ? disabledButtonStyle : buttonStyle}
            aria-label={previousText}
            aria-disabled={isFirstPage}
          >
            <i 
              className="icon-left-chevron" 
              style={{ fontSize: '24px', marginRight: '5px' }} 
              aria-hidden="true"
            />
            <span>Precedente</span>
          </button>

          {/* CURRENT PAGE INFO */}
          <Text 
            className="pag" 
            style={{
              fontSize: '12px',
              margin: '0 15px',
              display: 'inline-flex',
              alignItems: 'center'
            }}
          >
            Pagina {activePage} di {pages}
          </Text>

          {/* NEXT PAGE BUTTON */}
          <button
            onClick={() => this.changePage(activePage + 1)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.changePage(activePage + 1);
              }
            }}
            disabled={isLastPage}
            style={isLastPage ? disabledButtonStyle : buttonStyle}
            aria-label={nextText}
            aria-disabled={isLastPage}
          >
            <span>Successiva</span>
            <i 
              className="icon-right-chevron" 
              style={{ fontSize: '24px', marginLeft: '5px' }} 
              aria-hidden="true"
            />
          </button>
        </div>
      </nav>
    );
  }
}
